import {UserTracker} from "../index.js";

const eventDics = {
    "never-see" : "mini:never-see-again:click", // 다시보지 않기 클릭
    "notice-link" : "mini:notice-link:click" // 자세히보기? 클릭

}

export const MiniNoticeTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName, value = null) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value: value, data: {}});
    }

    return Tracker;
}
